<template>
<div>
	<nav class="mobile-nav sticky-bottom">
		<ul class="nav-list horizontal">
			<li class="nav-item">
				<router-link to="/products" class="nav-link" :class="{ active: isMenuActive('/products') }">
					<span class="nav-icon-label">
						<i class="fi fi-rr-box-alt"></i>
						<span>Product</span>
					</span>
				</router-link>
			</li>
			<li class="nav-item" v-if="isDropshipper">
				<router-link
					to="/wishlist"
					class="nav-link"
					:class="{ active: isMenuActive('/wishlist') }">
					<span class="nav-icon-label">
						<i class="fi fi-rr-heart"></i>
						<span>Wishlist</span>
					</span>
				</router-link>
			</li>
			<li class="nav-item">
				<router-link to="/wholesale-order/list" class="nav-link" :class="{ active: isMenuActive('/wholesale-order/list') }">
					<span class="nav-icon-label">
						<i class="fi fi-rr-shopping-cart-check"></i>
						<span>Order</span>
					</span>
				</router-link>
			</li>
			<li class="nav-item">
				<button class="nav-link" @click="openSubMenu('other')">
					<span class="nav-icon-label">
						<i class="fi fi-rr-list"></i>
						<span>Other</span>
					</span>
				</button>
			</li>
			<li class="nav-item">
				<button class="nav-link" @click="openSubMenu('user')">
					<span class="nav-icon-label">
						<i class="fi fi-rr-user"></i>
						<span>User</span>
					</span>
				</button>
			</li>
		</ul>
	</nav>

	<modal
		class="modal-nav-mobile-menu"
		size="small"
		v-if="isShowMenu"
		@close="isShowMenu = false"
		:hideFooter="true"
		:hideHeader="true"
	>
		<div slot="header">
			<div class="d-flex align-items-center">
				<h4 class="mb-0">
					<b class="">{{ activeMenu === 'other' ? 'Other Menu' : 'User Menu' }}</b>
				</h4>
			</div>
		</div>
		<div slot="body">
			<ul class="mobile-menu-list">
				<li
					class="mobile-menu-item"
					v-for="(item, index) in listSubMenu"
					:key="index"
				>
					<button class="btn btn-light w-100 text-left py-3 px-4" v-if="item.name === 'Logout'" @click="logout">
						<b>{{ item.name }}</b>
					</button>
					<router-link
						v-else
						:to="item.link"
						class="btn btn-light w-100 text-left py-3 px-4"
						@click.native="isShowMenu = false">
						<b>{{ item.name }}</b>
					</router-link>
				</li>
			</ul>
		</div>
	</modal>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';

const otherSubMenus = [
	{
		name: 'Inventory',
		icon: 'fi fi-rr-warehouse',
		link: '/inventory',
	},
	{
		name: 'Request Product',
		icon: 'fi fi-rr-bulb',
		link: '/request-product/list',
	},
];

const supplierSubMenus = [
	{
		name: 'Inventory',
		icon: 'fi fi-rr-warehouse',
		link: '/inventory',
	},
	{
		name: 'Team Members',
		icon: 'fi fi-rr-users-alt',
		link: '/members',
	},
];

const userSubMenus = [
	{
		name: 'Profile',
		icon: 'fi fi-rr-user',
		link: '/profile',
	},
	{
		name: 'Credits',
		icon: 'fi fi-rr-credit-card',
		link: '/credits',
	},
	{
		name: 'Billings',
		icon: 'fi fi-rr-credit-card',
		link: '/billings',
	},
	{
		name: 'Settings',
		icon: 'fi fi-rr-settings',
		link: '/settings',
	},
	{
		name: 'Logout',
		icon: 'fi fi-rr-exit',
		link: '/logout',
	},
];

export default {
	name: 'MobileMenu',
	components: {
		Modal,
	},
	data() {
		return {
			isShowMenu: false,
			activeMenu: '',
			listSubMenu: [],
		};
	},
	computed: {
		...mapGetters({
			isFetchingUser: 'isFetchingUser',
			user: 'user',
			isOwner: 'isOwner',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			settings: 'settings',
			isMenuActive: 'isMenuActive',
			isAdmin: 'isAdmin',
			isSupport: 'isSupport',
			isUserCan: 'isUserCan',
			announcements: 'announcements',
			notices: 'notice',
			noticePublics: 'noticePublics',
			appName: 'appName',
			appLogo: 'appLogo',
			isStorefrontActive: 'isStorefrontActive',
			isNewPlan: 'isNewPlan',
			isHasFeature: 'isHasFeature',
			searchQuery: 'homepage/searchQuery',
			searchType: 'homepage/searchType',
			searchBarPos: 'privateOrder/searchBarPos',
		}),
	},
	methods: {
		...mapActions({
			logout: 'logout',
		}),
		openSubMenu(menu) {
			this.isShowMenu = true;
			this.activeMenu = menu;
			if (menu === 'other') {
				if (this.isSupplier) {
					this.listSubMenu = supplierSubMenus;
				} else {
					this.listSubMenu = otherSubMenus;
				}
			} else if (menu === 'user') {
				this.listSubMenu = userSubMenus;
			}
		},
	},
};
</script>
<style lang="scss">
.mobile-nav.sticky-bottom {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	background: #fff;
	z-index: 1000;
	box-shadow: 0 -2px 8px rgba(0,0,0,0.05);
}
.nav-list.horizontal {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	margin: 0;
	padding: 0.5rem 0 .2rem 0;
	list-style: none;
}
.nav-item {
	position: relative;
}
.mobile-nav {
	.nav-link {
		color: #4d4d4d;
		text-decoration: none;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-weight: 600;

		&.router-link-active {
			color: #006DC7;
		}
	}
}
.nav-link {
	background: none;
	border: none;
	padding: 0.3rem 1rem;
	font-size: 13px;
}
.other-menu .sub-menu {
	display: none;
	position: absolute;
	bottom: 100%;
	left: 0;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0,0,0,0.1);
	list-style: none;
	margin: 0;
	padding: 0.5rem 0;
}
.other-menu:hover .sub-menu,
.other-menu:focus-within .sub-menu {
	display: block;
}

.nav-icon-label {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.modal-nav-mobile-menu {
	.modal-header {
		// display: none;
		background: #fff;
		border: 0px;
	}
}

.mobile-menu-list {
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: .5rem;
}
</style>
